import React from "react";
import Sidebar from "../../components/common/Sidebar";
import Header from "../../components/common/Header";
import DashboardMain from "../../components/dashboard/DashboardMain";
import Footer from "../../components/common/Footer";
import { RODEO_PAGE_NAME } from "../../_config";

const Dashboard = (props: Record<string, any>) => (
  <div className="drjob-dashboard-layout">
    <Header variant="topbar" />
    <div className="drjob-dashboard-wrapper">
      <Sidebar page={RODEO_PAGE_NAME.DASHBOARD} />
      <main className="drjob-main-content">
        <DashboardMain />
      </main>
    </div>
    <Footer variant="dashboard" />
  </div>
);

export default Dashboard;